import React, { useState, useEffect } from 'react';
import api from '../../api';
import { FaVideo, FaSave, FaCheckCircle, FaEdit, FaListUl, FaChartBar, FaYoutube } from 'react-icons/fa';
import styles from './Admin.module.css'; // Wahi module CSS

const AdminVideoSettings = () => {
  // --- State for all fields ---
  const [formData, setFormData] = useState({
    badgeText: '',
    title: '',
    subtitle: '',
    videoId: '', // Database me sirf ye jayega (e.g., dQw4w9WgXcQ)
    
    stat1_Label: '', stat1_Value: '',
    stat2_Label: '', stat2_Value: '',
    stat3_Label: '', stat3_Value: '',

    benefit1_Title: '', benefit1_Desc: '',
    benefit2_Title: '', benefit2_Desc: '',
    benefit3_Title: '', benefit3_Desc: '',
    benefit4_Title: '', benefit4_Desc: ''
  });

  // Ye state sirf Input box me dikhane ke liye hai (Taaki user ko pura link dikhe)
  const [videoInput, setVideoInput] = useState(''); 

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ text: '', type: '' });


  // --- 1. Fetch Current Data ---
  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
    const res = await api.get('/Video');
      if (res.data) {
        setFormData({
          badgeText: res.data.badgeText || '',
          title: res.data.title || '',
          subtitle: res.data.subtitle || '',
          videoId: res.data.videoId || '',
          
          stat1_Label: res.data.stat1_Label || '', stat1_Value: res.data.stat1_Value || '',
          stat2_Label: res.data.stat2_Label || '', stat2_Value: res.data.stat2_Value || '',
          stat3_Label: res.data.stat3_Label || '', stat3_Value: res.data.stat3_Value || '',

          benefit1_Title: res.data.benefit1_Title || '', benefit1_Desc: res.data.benefit1_Desc || '',
          benefit2_Title: res.data.benefit2_Title || '', benefit2_Desc: res.data.benefit2_Desc || '',
          benefit3_Title: res.data.benefit3_Title || '', benefit3_Desc: res.data.benefit3_Desc || '',
          benefit4_Title: res.data.benefit4_Title || '', benefit4_Desc: res.data.benefit4_Desc || ''
        });

        // Agar DB me ID hai, to usko wapas Link bana kar dikhao (User friendly)
        if (res.data.videoId) {
          setVideoInput(`https://www.youtube.com/watch?v=${res.data.videoId}`);
        }
      }
    } catch (err) {
      console.error("Error fetching video settings:", err);
    }
  };

  // --- 2. Helper Logic: Extract ID from Link ---
  const extractVideoId = (url) => {
    if (!url) return '';
    // Ye regex short link, full link, embed link sab handle karega
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return (match && match[2].length === 11) ? match[2] : '';
  };

  // --- 3. Handle Generic Change ---
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // --- 4. Handle Video Link Change ---
  const handleVideoChange = (e) => {
    const val = e.target.value;
    setVideoInput(val); // Input me wahi dikhao jo user type kar raha hai (Link)
    
    // Background me ID nikalo
    const extractedId = extractVideoId(val);
    
    // Agar valid ID mili to save karo, nahi to agar user delete kar raha hai to empty karo
    if (extractedId) {
      setFormData(prev => ({ ...prev, videoId: extractedId }));
    } else if (val === '') {
      setFormData(prev => ({ ...prev, videoId: '' }));
    }
    // Note: Agar invalid link hai to hum purani ID retain kar sakte hain ya empty, 
    // yahan hum strict extraction kar rahe hain.
  };

  // --- 5. Submit Form ---
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage({ text: '', type: '' });

    try {
      const token = localStorage.getItem('token');
     await api.post('/Video', formData);

      setMessage({ text: "Video Section Updated Successfully!", type: "success" });
    } catch (err) {
      setMessage({ text: "Update Failed! Please try again.", type: "error" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className={styles.formCard} style={{ maxWidth: '900px' }}>
        
        <h3 style={{ marginBottom: '1.5rem', color: '#4ade80', display: 'flex', alignItems: 'center', gap: '10px' }}>
          <FaVideo /> Update Video Section
        </h3>

        {/* Message Alert */}
        {message.text && (
          <div style={{
            padding: '12px', marginBottom: '20px', borderRadius: '8px',
            background: message.type === 'error' ? 'rgba(239, 68, 68, 0.15)' : 'rgba(74, 222, 128, 0.15)',
            color: message.type === 'error' ? '#fca5a5' : '#4ade80',
            border: message.type === 'error' ? '1px solid rgba(239, 68, 68, 0.3)' : '1px solid rgba(74, 222, 128, 0.3)',
            display: 'flex', alignItems: 'center', gap: '8px'
          }}>
            {message.type === 'success' && <FaCheckCircle />}
            {message.text}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          
          {/* --- Section 1: Main Video Info --- */}
          <h4 style={{ color: '#fff', borderBottom: '1px solid rgba(255,255,255,0.1)', paddingBottom: '10px', marginBottom: '15px' }}>
            <FaEdit style={{ marginRight: '8px', color: '#94a3b8' }} />
            Main Details
          </h4>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
            <div className={styles.formGroup}>
              <label>Badge Text</label>
              <input type="text" name="badgeText" value={formData.badgeText} onChange={handleChange} className={styles.formInput} placeholder="e.g. Watch Our Work" />
            </div>
            
            {/* --- SMART VIDEO INPUT --- */}
            <div className={styles.formGroup}>
              <label style={{ color: '#ff0000', display:'flex', alignItems:'center', gap:'5px' }}>
                <FaYoutube /> YouTube Video Link
              </label>
              <input 
                type="text" 
                value={videoInput} 
                onChange={handleVideoChange} 
                className={styles.formInput} 
                placeholder="Paste full YouTube link here..." 
              />
              {/* Validation Feedback */}
              <small style={{ color: formData.videoId.length === 11 ? '#4ade80' : '#64748b', display: 'block', marginTop: '5px' }}>
                {formData.videoId.length === 11 
                  ? `✅ Video Detected (ID: ${formData.videoId})` 
                  : "Please paste a valid YouTube URL"}
              </small>
            </div>
          </div>

          <div className={styles.formGroup}>
            <label>Main Title</label>
            <input type="text" name="title" value={formData.title} onChange={handleChange} className={styles.formInput} />
          </div>

          <div className={styles.formGroup}>
            <label>Subtitle / Description</label>
            <textarea name="subtitle" value={formData.subtitle} onChange={handleChange} className={styles.formInput} rows="2" />
          </div>

          {/* --- Section 2: Statistics --- */}
          <h4 style={{ color: '#fff', borderBottom: '1px solid rgba(255,255,255,0.1)', paddingBottom: '10px', marginBottom: '15px', marginTop: '25px' }}>
            <FaChartBar style={{ marginRight: '8px', color: '#94a3b8' }} />
            Statistics (Below Video)
          </h4>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '15px' }}>
            {/* Stat 1 */}
            <div style={{ background: 'rgba(255,255,255,0.05)', padding: '15px', borderRadius: '10px' }}>
              <div className={styles.formGroup} style={{marginBottom:'10px'}}>
                <label>Stat 1 Value</label>
                <input type="text" name="stat1_Value" value={formData.stat1_Value} onChange={handleChange} className={styles.formInput} placeholder="e.g. 2-4 Days" />
              </div>
              <div className={styles.formGroup} style={{marginBottom:0}}>
                <label>Stat 1 Label</label>
                <input type="text" name="stat1_Label" value={formData.stat1_Label} onChange={handleChange} className={styles.formInput} placeholder="Installation Time" />
              </div>
            </div>

            {/* Stat 2 */}
            <div style={{ background: 'rgba(255,255,255,0.05)', padding: '15px', borderRadius: '10px' }}>
              <div className={styles.formGroup} style={{marginBottom:'10px'}}>
                <label>Stat 2 Value</label>
                <input type="text" name="stat2_Value" value={formData.stat2_Value} onChange={handleChange} className={styles.formInput} placeholder="e.g. 500+" />
              </div>
              <div className={styles.formGroup} style={{marginBottom:0}}>
                <label>Stat 2 Label</label>
                <input type="text" name="stat2_Label" value={formData.stat2_Label} onChange={handleChange} className={styles.formInput} placeholder="Projects" />
              </div>
            </div>

            {/* Stat 3 */}
            <div style={{ background: 'rgba(255,255,255,0.05)', padding: '15px', borderRadius: '10px' }}>
              <div className={styles.formGroup} style={{marginBottom:'10px'}}>
                <label>Stat 3 Value</label>
                <input type="text" name="stat3_Value" value={formData.stat3_Value} onChange={handleChange} className={styles.formInput} placeholder="e.g. 100%" />
              </div>
              <div className={styles.formGroup} style={{marginBottom:0}}>
                <label>Stat 3 Label</label>
                <input type="text" name="stat3_Label" value={formData.stat3_Label} onChange={handleChange} className={styles.formInput} placeholder="Quality" />
              </div>
            </div>
          </div>

          {/* --- Section 3: Benefits List --- */}
          <h4 style={{ color: '#fff', borderBottom: '1px solid rgba(255,255,255,0.1)', paddingBottom: '10px', marginBottom: '15px', marginTop: '25px' }}>
            <FaListUl style={{ marginRight: '8px', color: '#94a3b8' }} />
            Key Benefits (Right Side List)
          </h4>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
            {/* Benefit 1 */}
            <div>
              <div className={styles.formGroup}>
                <label style={{color: '#4ade80'}}>Benefit 1 Title (Tools Icon)</label>
                <input type="text" name="benefit1_Title" value={formData.benefit1_Title} onChange={handleChange} className={styles.formInput} />
              </div>
              <div className={styles.formGroup}>
                <textarea name="benefit1_Desc" value={formData.benefit1_Desc} onChange={handleChange} className={styles.formInput} rows="2" placeholder="Description..." />
              </div>
            </div>

            {/* Benefit 2 */}
            <div>
              <div className={styles.formGroup}>
                <label style={{color: '#f59e0b'}}>Benefit 2 Title (Clock Icon)</label>
                <input type="text" name="benefit2_Title" value={formData.benefit2_Title} onChange={handleChange} className={styles.formInput} />
              </div>
              <div className={styles.formGroup}>
                <textarea name="benefit2_Desc" value={formData.benefit2_Desc} onChange={handleChange} className={styles.formInput} rows="2" placeholder="Description..." />
              </div>
            </div>

            {/* Benefit 3 */}
            <div>
              <div className={styles.formGroup}>
                <label style={{color: '#3b82f6'}}>Benefit 3 Title (Mobile Icon)</label>
                <input type="text" name="benefit3_Title" value={formData.benefit3_Title} onChange={handleChange} className={styles.formInput} />
              </div>
              <div className={styles.formGroup}>
                <textarea name="benefit3_Desc" value={formData.benefit3_Desc} onChange={handleChange} className={styles.formInput} rows="2" placeholder="Description..." />
              </div>
            </div>

            {/* Benefit 4 */}
            <div>
              <div className={styles.formGroup}>
                <label style={{color: '#22c55e'}}>Benefit 4 Title (Cert Icon)</label>
                <input type="text" name="benefit4_Title" value={formData.benefit4_Title} onChange={handleChange} className={styles.formInput} />
              </div>
              <div className={styles.formGroup}>
                <textarea name="benefit4_Desc" value={formData.benefit4_Desc} onChange={handleChange} className={styles.formInput} rows="2" placeholder="Description..." />
              </div>
            </div>
          </div>

          <button type="submit" className={styles.primaryBtn} disabled={loading} style={{ marginTop: '20px' }}>
            {loading ? 'Saving...' : <><FaSave /> Save Changes</>}
          </button>

        </form>
      </div>
    </div>
  );
};

export default AdminVideoSettings;